import { useEffect, useState } from "react";
import { g, eur } from "@/lib/api";
import { usePlan } from "@/context/PlanContext";
import { PremiumLock } from "@/components/PremiumLock";
import { Card } from "@/components/ui/card";

export default function Storico() {
  const { has } = usePlan();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (has("order_history")) g("/orders/history/all").then(setRows).catch(() => {});
  }, [has]);

  if (!has("order_history"))
    return (
      <PremiumLock
        title="Storico ordini"
        description="Tutti i conti chiusi con articoli, coperti, sconti e metodo di incasso."
        needed="standard"
        message="Lo storico ordini è incluso dal piano Standard"
        preview={
          <div className="p-6">
            <Card className="p-5">
              <table className="w-full text-sm">
                <tbody>
                  {[["Tavolo 3", "44,00 €"], ["Tavolo 9", "58,00 €"], ["Tavolo 22", "31,50 €"]].map(([a, b]) => (
                    <tr key={a} className="border-b border-slate-100 last:border-0">
                      <td className="py-3 font-medium">{a}</td>
                      <td className="py-3 text-right font-num">{b}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          </div>
        }
      />
    );

  return (
    <div className="fade-up space-y-5" data-testid="storico-page">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-slate-500">Piano Standard</p>
        <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl">Storico ordini</h1>
      </div>

      <Card className="p-5" data-testid="storico-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left text-[10px] uppercase tracking-[0.16em] text-slate-500">
                <th className="py-2 pr-3 font-bold">Chiuso</th>
                <th className="py-2 pr-3 font-bold">Tavolo</th>
                <th className="py-2 pr-3 font-bold">Cameriere</th>
                <th className="py-2 pr-3 font-bold">Coperti</th>
                <th className="py-2 pr-3 font-bold">Articoli</th>
                <th className="py-2 pr-3 font-bold">Incasso</th>
                <th className="py-2 text-right font-bold">Totale</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((o) => (
                <tr key={o.id} className="border-b border-slate-100 last:border-0" data-testid={`storico-${o.id}`}>
                  <td className="py-2.5 pr-3 font-num text-slate-500">
                    {o.closed_at ? new Date(o.closed_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—"}
                  </td>
                  <td className="py-2.5 pr-3 font-medium">{o.group_name || o.table_numbers.join(" + ")}</td>
                  <td className="py-2.5 pr-3 text-slate-600">{o.waiter}</td>
                  <td className="py-2.5 pr-3 font-num">{o.covers}</td>
                  <td className="py-2.5 pr-3 font-num">{o.items.length}</td>
                  <td className="py-2.5 pr-3 text-slate-500">
                    {o.payments.filter((x) => !x.voided).map((x) => x.method).join(", ") || "—"}
                  </td>
                  <td className="py-2.5 text-right font-num font-semibold">{eur(o.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <p className="py-6 text-sm text-slate-500">Nessun conto chiuso.</p>}
        </div>
      </Card>
    </div>
  );
}
